// src/components/SessionWrapper.js

import React from 'react';

export default function SessionWrapper({ email, handleLogout, children }) {
  return (
    <div style={{ position: 'relative' }}>
      {email && handleLogout && (
        <div style={{
          position: 'absolute',
          top: '1rem',
          right: '1rem',
          fontSize: '0.9rem',
          color: '#555',
          zIndex: 1000
        }}>
          Hi <strong>{email}</strong>,{" "}
          <span
            onClick={handleLogout}
            style={{ color: '#007bff', cursor: 'pointer', textDecoration: 'underline' }}
          >
            logout
          </span>
        </div>
      )}
      {children}
    </div>
  );
}
